const SAMAGRI = [
  { icon: 'fa-bowl-food', name: 'Metallic Vessel', note: 'For the panchamrit bath' },
  { icon: 'fa-glass-water', name: 'Unboiled Cow’s Milk', note: 'Fresh and pure' },
  { icon: 'fa-water', name: 'Ganga Jal', note: 'Sacred Ganges water' },
  { icon: 'fa-leaf', name: 'Tulsi Leaves', note: 'Holy basil' },
  { icon: 'fa-jar', name: 'Honey & Ghee', note: 'Completes the panchamrit' },
  { icon: 'fa-fan', name: 'Fresh Flowers', note: 'For the altar' },
  { icon: 'fa-fire-flame-simple', name: 'Sandalwood Incense', note: 'Chandan agarbatti' },
  { icon: 'fa-plate-wheat', name: 'Cloth & Offering Plate', note: 'Clean cloth to dry the stone' },
]

export default function SamagriSection() {
  return (
    <section className="py-20 md:py-24 md:px-12 bg-background">
      <div className="container mx-auto max-w-350 px-6 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-28 space-y-4">
            <div className="flex items-center gap-3">
              <span className="h-px w-8 bg-secondary/50"></span>
              <span className="text-[10px] uppercase tracking-[0.4em] text-secondary font-bold">Puja Samagri</span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl uppercase leading-tight text-primary">
              What the Ritual <span className="text-gradient-gold font-bold block">Requires</span>
            </h2>
            <p className="max-w-sm text-xs md:text-sm leading-relaxed text-gray-500">
              Each item of the samagri has a role in the vidhi — together they purify, sanctify and awaken the gemstone. Our priests prepare everything; if you wish to re-energize a stone at home, this is your checklist.
            </p>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4">
            {SAMAGRI.map((item) => (
              <div key={item.name} className="flex items-center gap-4 rounded-2xl border border-gray-200 bg-white/80 p-5 shadow-sm transition-all duration-300 hover:border-secondary/30 hover:shadow-md">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary/10 text-secondary">
                  <i className={`fa-solid ${item.icon} text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-sm uppercase tracking-wide text-primary font-bold">{item.name}</h3>
                  <p className="mt-0.5 text-xs text-gray-400">{item.note}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
